import { IStyle, makeStyles } from '@fluentui/react';

const CHECK_CELL_WIDTH = 80;


export const useStyles = makeStyles((theme) => ({
  container: {
    width: '80vw',
    height: '70vh',
  },
  containerExpanded: {
    width: '80vw',
    height: '90vh',
  },
  modalContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
  },
  stickyInsideStack: {
    padding: 25,
    paddingBottom: 15,
    marginBottom: 20,
    backgroundColor: theme.palette.neutralLight,
  },
  row: {
    minWidth: '100% !important',
  },
  stickyInsideBottomStack: {
    padding: 25,
    paddingBottom: 15,
    justifyContent: 'flex-end',
  },
  amountStack: {
    fontWeight: 'bold',
    marginLeft: 0,
    display: 'block',
  },
  headerContainer: {
    boxShadow: `-7px 2px 13px rgba(0, 0, 0, 0.10)`,
    backgroundColor: theme.palette.white,
  },
  shareIcon: {
    color: theme.palette.neutralSecondary,
    fontSize: 20,
  },
  onrenderColumnStack: {
    height: 25,
  },
  contentColumnAlignRight: {
    display: 'block',
    textAlign: 'right',
  },
  reviewGrid: {
    selectors: {
      ' .ms-DetailsHeader-cellIsCheck, .ms-DetailsRow-cellCheck': {
        width: `${CHECK_CELL_WIDTH}px !important`,
        minWidth: `${CHECK_CELL_WIDTH}px !important`,
        overflow: 'visible !important',
      },
      ' .ms-DetailsRow-check:not(.ms-DetailsRow-check--isDisabled)': {
        width: '100% !important',
        display: 'flex !important',
        alignItems: 'center',
        justifyContent: 'flex-start !important',
        paddingLeft: 8,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
      },
      ' .ms-DetailsRow-check:not(.ms-DetailsRow-check--isDisabled)::after': {
        content: '"Reviewed"',
        marginLeft: 6,
        fontSize: 10,
        lineHeight: '12px',
        color: theme.palette.neutralTertiary,
      },
      ' .ms-DetailsRow-check[aria-checked="true"]::after': {
        color: theme.palette.neutralPrimary,
      },
    },
  } as unknown as IStyle,
}));
